import moment from "moment";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";
import { TChatMessage } from "../../../interfaces/enquiry.interface";

export const ChatMessage: React.FC<{
  messageDetails: TChatMessage;
}> = ({ messageDetails }) => {
  const imageFormats = ["jpg", "jpeg", "png"];
  return (
    <div
      className={`${enquiryscss.chatMsg} me- d-flex ${
        messageDetails.ownMessage ? "justify-content-end" : ""
      }`}
      style={{
        marginTop: messageDetails.ownMessage ? "8px" : "13px",
      }}
    >
      <div
        className={`${enquiryscss.chatContent} ${
          messageDetails.ownMessage
            ? `${enquiryscss.ownMessage}`
            : `${enquiryscss.receiveMessage}`
        }`}
      >
        <span className={enquiryscss.chatPerson}>
          {messageDetails.senderDetails.name}
        </span>
        <div className={enquiryscss.remarkMessage}>
          <div className={enquiryscss.messageImage}>
            {messageDetails.documentUrl && messageDetails.documentType && (
              <>
                {imageFormats.includes(messageDetails.documentType) ? (
                  <img
                    src={messageDetails.documentUrl}
                    alt=""
                    width={150}
                    height={150}
                  />
                ) : (
                  <i className="fa-solid fa-file-pdf h1"></i>
                )}

                {messageDetails.ownMessage ? (
                  <a
                    className={enquiryscss.documentDownloadLeftBtn}
                    href={messageDetails.documentUrl}
                  >
                    {" "}
                    <i className="fa-solid fa-download border p-2 rounded-circle text-success border-success "></i>
                  </a>
                ) : (
                  <a
                    className={enquiryscss.documentDownloadRightBtn}
                    href={messageDetails.documentUrl}
                  >
                    {" "}
                    <i className="fa-solid fa-download border p-2 rounded-circle text-success border-success "></i>
                  </a>
                )}
              </>
            )}
          </div>
          {messageDetails.message}

          <br />
        </div>

        <div className={enquiryscss.chatSend}>
          <span className={enquiryscss.enquiryTime}>
            {moment(messageDetails.createdAt).format("h:mm a")}
          </span>
          {messageDetails.ownMessage && (
            <span className={`${enquiryscss.enquiryDate} ps-2`}>
              {messageDetails?.send ? (
                <i className="fas fa-check text-success"></i>
              ) : (
                <i className="fas fa-history"></i>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
